import { observer } from 'mobx-react'

import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type { RestDay, ShiftsRow } from 'modules/shift_management/lib/types'

import RestDayLayout from './RestDayLayout'

interface Props {
  restDay: RestDay
  shiftsRow: ShiftsRow
}

const RestDayCell = ({ restDay, shiftsRow }: Props) => {
  const { restDays, isEnabled: isSelectionEnabled } = useSelectionState()
  const isSelected = !!restDays[restDay.id]

  return (
    <RestDayLayout
      restDay={restDay}
      shiftsRow={shiftsRow}
      isSelectionEnabled={isSelectionEnabled}
      isSelected={isSelected}
    />
  )
}

export default observer(RestDayCell)
